
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"27","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#56BDD2","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M33.547 0H4.453C1.998 0 0 2.019 0 4.5v18C0 24.981 1.998 27 4.453 27h29.094C36.002 27 38 24.981 38 22.5v-18C38 2.019 36.002 0 33.547 0zm2.226 22.5c0 1.24-.998 2.25-2.226 2.25H4.453c-1.228 0-2.226-1.01-2.226-2.25v-18c0-1.24.998-2.25 2.226-2.25h29.094c1.228 0 2.226 1.01 2.226 2.25v18z"}}),_c('path',{attrs:{"d":"M4 4v9h10V4H4zm7.778 6.75H6.222v-4.5h5.556v4.5zM26 15h8v3h-8zM30 4h4v3h-4zM15 15h8v3h-8zM4 15h8v3H4z"}})])])
          )
        }
      }
    